export default __webpack_public_path__ + "static/clean-ingredients_real-people_Chris-3ef01ebbb6e299ffaef422b6f10cd99d.png";